interface ValidatedAddressProperty {
  PropertyId?: number | string
  ExternalId?: string
  FullAddress?: string
}

interface ValidatedAddress {
  Property?: ValidatedAddressProperty
}

interface PlacekeyExternalIds {
  public_record_id?: string
  cid?: string
}

interface PlacekeyData {
  external_ids?: PlacekeyExternalIds
}

interface PropertyPayload {
  validatedAddress?: ValidatedAddress
  placekeyData?: PlacekeyData
  formattedAddress?: string
}

const formatAddressForUrl = (address?: string): string => {
  if (!address) return ''

  return address
    .replace(/,/g, '')
    .replace(/ /g, '-')
    .replace('#', 'unit-')
    .trim()
    .toLowerCase()
}

const buildValueUrl = (
  formattedAddress: string,
  propertyId?: string,
): string => {
  if (!formattedAddress) return ''

  const suffix = propertyId ? `-${propertyId}` : ''
  return `/my-value/${formattedAddress}${suffix}`
}

export const generateValueUrl = (payload: PropertyPayload): string => {
  if (payload.validatedAddress) {
    return generateValueUrlFromValidatedAddress(payload.validatedAddress)
  }

  if (payload.placekeyData) {
    return generateValueUrlFromPlacekeyData(payload)
  }

  return ''
}

export const generateValueUrlFromPlacekeyData = (
  payload: PropertyPayload,
): string => {
  const externalIds = payload.placekeyData?.external_ids
  if (!externalIds) return ''

  const propertyId =
    externalIds.public_record_id ||
    (externalIds.cid ? `${externalIds.cid}c` : '')
  const formattedAddress = formatAddressForUrl(payload.formattedAddress)

  return buildValueUrl(formattedAddress, propertyId)
}

export const generateValueUrlFromValidatedAddress = (
  validatedAddress: ValidatedAddress,
): string => {
  const property = validatedAddress?.Property
  if (!property) return ''

  const propertyId = String(property.PropertyId || property.ExternalId || '')
  const formattedAddress = formatAddressForUrl(property.FullAddress)

  return buildValueUrl(formattedAddress, propertyId)
}
